export default __webpack_public_path__ + "static/media/marketkit_wrapper.e104e7e5.svg";